import { render, staticRenderFns } from "./PersonIdentification.vue?vue&type=template&id=9043e494&scoped=true&"
import script from "./PersonIdentification.vue?vue&type=script&lang=js&"
export * from "./PersonIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9043e494",
  null
  
)

export default component.exports